import { useState } from "react";
import Alert from "./Alert";
import "./App.css";
import Navigation from "./Navigation";
import TextArea from "./TextArea";

function App() {
  const [mode, setMode] = useState("light");
  const [alert, setAlert] = useState(null);
  const [modeType, setModeType] = useState("Enable Darkmode");

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 2000);
  };

  const toggleMode = () => {
    if (mode === "light") {
      setMode("dark");
      setModeType("Disable Darkmode");
      document.body.style.backgroundColor = "#2F3131";
      // showAlert("Dark Mode Is Enabled", "Success");
    } else {
      setMode("light");
      setModeType("Enable Darkmode");
      document.body.style.backgroundColor = "#fff";
      // showAlert("Light Mode Is Enabled", "Success");
    }
  };

  return (
    <>
      <Navigation mode={mode} toggleMode={toggleMode} modeType={modeType} />
      <Alert alert={alert} />
      <TextArea mode={mode} showAlert={showAlert} />
    </>
  );
}

export default App;
